import { Suspense, useState } from 'react';
import { hydrate, QueryClient, QueryClientProvider } from '@tanstack/react-query';

import { I18nProvider } from '@cx-modules/i18n-provider';

import { type OffersGroupedIndexProps } from '../contract';

import OffersGrouped from './OffersGrouped';

const createQueryClient = (nocache?: boolean) =>
  new QueryClient({
    defaultOptions: {
      queries: {
        gcTime: nocache ? 0 : undefined,
        refetchOnMount: nocache ? true : false,
        staleTime: nocache ? 0 : Infinity,
      },
    },
  });

export default function OffersGroupedWithQuery({
  dehydratedState,
  loadingSlot,
  nocache,
  ...props
}: OffersGroupedIndexProps) {
  const [queryClient] = useState(() => {
    const client = createQueryClient(nocache);
    hydrate(client, dehydratedState);
    return client;
  });

  return (
    <QueryClientProvider client={queryClient}>
      <I18nProvider i18nInstance={props.i18n}>
        <Suspense fallback={loadingSlot ?? <div>Loading...</div>}>
          <OffersGrouped {...props} />
        </Suspense>
      </I18nProvider>
    </QueryClientProvider>
  );
}

export { loadDataForServer } from './loadData';
export type { OffersGroupedIndexProps } from '../contract';
